function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomHillSideViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28.73 2.165H3c-.55 0-1 .45-1 1v25.86c0 .55.45 1 1 1h25.73c.55 0 1-.45 1-1V3.165c0-.55-.45-1-1-1zm-9.78 16.53c2.76-.97 6.39-1.12 8.78-1v7.45c-2.65-2.96-5.7-5.03-8.78-6.45zm-2.55-1.03a34.83 34.83 0 00-3.44-1.01c.15-1.96 1.78-3.52 3.78-3.52 1.85 0 3.39 1.32 3.74 3.07-1.48.31-2.9.77-4.08 1.45v.01zm11.33-13.5v11.53c-1.41-.06-3.3-.05-5.27.19-.5-2.7-2.87-4.75-5.71-4.75s-5.42 2.24-5.76 5.11c-2.74-.49-5.19-.6-6.99-.58v-11.5h23.73zM4 17.665c5.27-.05 16.48 1.06 23.51 10.36H4v-10.36z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.81 12.435c.23 0 .45-.08.64-.23l1.95-1.63a1 1 0 00.12-1.41.998.998 0 00-1.41-.12l-1.95 1.63a1 1 0 00-.12 1.41c.2.24.48.36.77.36v-.01zM9.82 12.495c.18.14.4.21.62.21.3 0 .59-.13.79-.38a.992.992 0 00-.17-1.4l-2-1.57a.99.99 0 00-1.4.17.992.992 0 00.17 1.4l2 1.57h-.01zM16.81 9.905c.55 0 1-.45 1-1v-2.15c0-.55-.45-1-1-1s-1 .45-1 1v2.15c0 .55.45 1 1 1z",
    fill: props.color
  }));
}

export default SvgIconRoomHillSideViewFilled;